import { useCallback, useReducer } from 'react';

import { deploymentUrl } from '@personly/libs-urls';
import { useNotifications } from '@personly/libs-providers';

import { useResources } from '@/providers/resources';

type Client = {
  id: string;
  name: string;
  redirectUris: string[];
  scopes: string[];
};

type State = Client;

const initialState: State = {
  id: '',
  name: '',
  redirectUris: [''],
  scopes: [],
};

enum ActionType {
  CLIENT_FETCHED,
}

type Action = {
  type: ActionType.CLIENT_FETCHED;
  client: Client;
};

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case ActionType.CLIENT_FETCHED: {
      return action.client;
    }

    default:
      return state;
  }
};

const useClients = () => {
  const [client, dispatch] = useReducer(reducer, initialState);
  const { createNotification } = useNotifications();
  const resources = useResources();

  const getClient = useCallback(
    async (id: string) => {
      const url = deploymentUrl('/agon/v1/getClient');
      url.searchParams.set('id', id);

      try {
        const { result } = await resources<Client>(url);

        dispatch({ type: ActionType.CLIENT_FETCHED, client: result });
      } catch (e) {
        if (e instanceof Error) {
          const handle = e.message ?? 'ERROR';
          createNotification('ERROR', handle);
        }
      }
    },
    [resources, createNotification]
  );

  return { client, getClient };
};

export default useClients;
